import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import AddClubHeader from "../../components/Headers/AddClubHeader.js";
import helper from '../../services/helper.service.js';
import customerClient from '../../services/customer.service.js';
import sessionService from '../../services/session.service.js';
import { generateTimeOptions } from '../../utils/date.js';

function Settings() {
  const club = sessionService.get('clubInfo');
  const [settings, setSettings] = useState({
    club_id: club.clubId,
    map_marker_label: club.map_marker_label || 'start_time',
    notification_start: club.notification_start,
    notification_end: club.notification_end,
    auto_game_start: club.auto_game_start,
    auto_game_end: club.auto_game_end,
    
  });

  const handleChange = (event, key) => {
    setSettings({ ...settings, [key]: event.target.value });
  };

  const handleSubmit = async () => {
    try {
      const response = await customerClient.updateClub(settings);
      if (response.status === 200) {
        const data = response.data;
        sessionService.set('clubInfo', 
          { ...club, map_marker_label: data.map_marker_label, 
            notification_start: data.notification_start, 
            notification_end: data.notification_end,
            auto_game_start: data.auto_game_start, 
            auto_game_end: data.auto_game_end,
          });
        helper.showToast("Success", "Settings updated successfully.", 1);
      } else {
        helper.showToast("Error", "Failed to update settings.", 3);
      }
    } catch (error) {
      console.error("Error updating settings: ", error);
      helper.showToast("Error", "Invalid club details", 3);
    }
  };

  return (
    <>
      <AddClubHeader />
      <Container className="mt--9" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <h3 className="mb-0">Settings</h3>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">Settings</h6>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label">Select Map Marker Label</label>
                        <Input
                          type="select"
                          value={settings.map_marker_label}
                          onChange={(e) => handleChange(e, 'map_marker_label')}
                        >
                          <option value="start_hole">Start Hole</option>
                          <option value="start_time">Tee Time</option>
                          <option value="actual_time">Start Time</option>
                          <option value="caddie_name">Caddie Name</option>
                          <option value="tracker_number">Tracker #</option>

                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <label className="form-control-label">Text Notification Start</label>
                        <Input
                          type="select"
                          value={settings.notification_start}
                          onChange={(e) => handleChange(e, "notification_start")}
                        >
                          {generateTimeOptions()}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <label className="form-control-label">Text Notification End</label>
                        <Input
                          type="select"
                          value={settings.notification_end}
                          onChange={(e) => handleChange(e, "notification_end")}
                        >
                          {generateTimeOptions()}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <label className="form-control-label">Auto Game Start</label>
                        <Input
                          type="select"
                          value={settings.auto_game_start}
                          onChange={(e) => handleChange(e, "auto_game_start")}
                        >
                          {generateTimeOptions()}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <label className="form-control-label">Auto Game End</label>
                        <Input
                          type="select"
                          value={settings.auto_game_end}
                          onChange={(e) => handleChange(e, "auto_game_end")}
                        >
                          {generateTimeOptions()}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <Button color="primary" onClick={handleSubmit}>
                        Save Settings
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Settings;
